import axios from 'axios'
import { util } from 'pevueglobal'

axios.defaults.withCredentials = true

export const HTTP = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8; multipart/form-data;'
  }
})

export function axiosGet() {
  const axiosInstance = axios.create({
    retry: 5,
    retryDelay: 2000
  })
  addErrorHandler(axiosInstance)
  return axiosInstance
}

// public api zonder kong api key
export function HTTPapiPublic(token) {
  // If there is a token, send token
  token = token || util.UgetCookie('kongapikey')
  const headers = token
    ? { Authorization: 'bearer ' + token, } 
    : null

  const config = {
    baseURL: PEGLOBALS.apiurl,
    retry: 5,
    retryDelay: 2000,
    headers
  }

  const axiosInstance = axios.create(config)
  addErrorHandler(axiosInstance)

  return axiosInstance
}

export function HTTPapiLocal() {
  const axiosInstance = axios.create({
    baseURL: 'http://localhost:8004'
  })
  addErrorHandler(axiosInstance)

  return axiosInstance
}

// api met kong api key
export function HTTPapi(token) {
  const config = {
    // baseURL: 'http://localhost:8004',
    // baseURL: 'http://localhost:5001',
    baseURL: PEGLOBALS.apiurl,
    headers: {
      Authorization: 'bearer ' + token || util.UgetCookie('kongapikey'),
    },
    retry: 2,
    // retryDelay: 200
  }

  const axiosInstance = axios.create(config)
  addErrorHandler(axiosInstance)
  
  return axiosInstance
}

function addErrorHandler(axiosInstance) {
  axiosInstance.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    err.config.__retryCount = err.config.__retryCount || 0
    err.config.__retryCount++

    // jwt verlopen of andere error die toegang tot resource tegenhoud
    if (err.response && err.response.status === 401) {
        const originalRequest = err.config
        // Get token and execute the call again
        return util.getTokenAsync().then(token => {
          if (token && err.config.retry && err.config.__retryCount <= err.config.retry) {
            originalRequest.headers['Authorization'] = 'bearer ' + token
            return axiosInstance(originalRequest)
          }

          util.throwException(`401, token: ${token || util.UgetCookie('kongapikey')}, refreshtoken: ${util.UgetCookie('kongapirefreshtoken')}`, {
            Error: err
          })

          window.location = '/logout.aspx'

          return Promise.reject(err)
        })
    }

    if (err.response && err.response.status === 403) {
        util.throwException(`403, token: ${util.UgetCookie('kongapikey')}, refreshtoken: ${util.UgetCookie('kongapirefreshtoken')}`, {
          Error: err
        })

        window.location = '/peapp/403'

        return Promise.reject(err)
    }

    var hostname = window.location.hostname
    if (hostname === 'www.pe-online.org' || hostname === 'opleidingen.knb.nl') {
      if (err.response && err.response.status >= 500) {
        // alleen bij server errors sentry errors melden
        util.throwException('onbekende fout tijdens verzenden api', {
          Error: err
        })
      }
    } else {
      // gene live server dus alle errors loggen, ook die van geen authorisatie of 401 etc.
      // alleen bij server errors sentry errors melden
      util.throwException('onbekende fout tijdens verzenden api', {
        Error: err
      })
    }

    // util.DoRefreshPEAndApi() // check of de token er wel is

    return Promise.reject(err)

    // var config = err.config

    // // If config does not exist or the retry option is not set, reject
    // if (!config || !config.retry) return Promise.reject(err)

    // // Set the variable for keeping track of the retry count
    // config.__retryCount = config.__retryCount || 0

    // // Check if we've maxed out the total number of retries
    // if (config.__retryCount >= config.retry) {
    //   EventBus.$emit('apperror')
    //   if (err.response === undefined){
    //     Raven.captureException(err,{
    //       extra: {
    //         status: 'netwerk error er is geen status terug gekomen van de server'
    //       }
    //     })

    //   } else {

    //   }
    //   return Promise.reject(err)
    // }

    // // Increase the retry count
    // config.__retryCount += 1

    // // Create new promise to handle exponential backoff
    // var backoff = new Promise(function(resolve) {
    //     setTimeout(function() {
    //         resolve()
    //     }, config.retryDelay || 1)
    // })

    // // Return the promise in which recalls axios to retry the request
    // return backoff.then(function() {
    //     return axiosInstance.request(config)
    // })
  })
}
